import Phaser from 'phaser';
import { BOMB_FUSE_MS } from '../constants';
export class BombAnimationController {
  private phase = 0;
  constructor(private sprite: Phaser.GameObjects.Sprite) { sprite.setOrigin(0.5, 0.7); }
  update(delta: number, timer: number): void {
    const progress = Phaser.Math.Clamp(1 - timer / BOMB_FUSE_MS, 0, 1);
    this.phase += delta / 1000 * (1.2 + progress * 3.3);
    this.sprite.setFrame(`bombs/${Math.min(5, Math.floor(progress * 6))}`);
    this.sprite.setScale(0.48 * (0.94 + Math.sin(this.phase * Math.PI * 2) * 0.06));
  }
}
